import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=c6c5ef5c"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c5ef5c')) {
      api.createRecord('c6c5ef5c', component.options)
    } else {
      api.reload('c6c5ef5c', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=c6c5ef5c", function () {
      api.rerender('c6c5ef5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Default.vue"
export default component.exports